// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { InsurancePolicies_InsurancePolicyFragment } from '../../../entities/InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import { gql } from '@apollo/client';
import { InsurancePolicies_InsurancePolicyFragmentDoc } from '../../../entities/InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateLifeInsurances_OwnerFragment = { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null };

export type EstateLifeInsurances_BeneficiaryFragment = { __typename?: 'Beneficiary', id: string };

export type EstateLifeInsurances_DispositionScenarioFragment = { __typename?: 'DispositionScenario', id: string, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, isPrimary: boolean, displayName: string }, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & EstateLifeInsurances_DispositionRecipientFragment
      ) | null } | null> | null }, secondDeathDispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & EstateLifeInsurances_DispositionRecipientFragment
      ) | null } | null> | null } };

export type EstateLifeInsurances_DispositionRecipientFragment = { __typename?: 'DispositiveProvision', id: string, recipientKind?: Types.DispositiveProvisionRecipientKind | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null };

export type EstateLifeInsurances_BeneficiaryDesignationsFragment = { __typename?: 'BeneficiaryDesignations', primary?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
          { __typename?: 'DispositiveProvision' }
          & EstateLifeInsurances_DispositionRecipientFragment
        ) | null } | null> | null } } | null };

export type EstateLifeInsurances_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, ownedByStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, owningEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null }> | null, subtype: { __typename?: 'CCorpBusinessEntity', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'CLTTrust', displayName: string, id: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, lifetimeBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, remainderBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'CRTTrust', displayName: string, id: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, lifetimeBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, remainderBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'CustodialPersonalAccount', displayName: string, id: string, owner?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'DonorAdvisedFund', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'GPBusinessEntity', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'GRATTrust', displayName: string, id: string, grantor?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'ILITTrust', displayName: string, id: string, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'IndividualPersonalAccount', displayName: string, id: string, owner?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'InsurancePersonalAccount', displayName: string, id: string, owners?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, beneficiaryDesignations: (
      { __typename?: 'BeneficiaryDesignations' }
      & EstateLifeInsurances_BeneficiaryDesignationsFragment
    ), dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'IrrevocableTrust', displayName: string, id: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'JointPersonalAccount', displayName: string, id: string, owners?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'LLCBusinessEntity', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'LPBusinessEntity', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'PrivateFoundation', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'QPRTTrust', displayName: string, id: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', displayName: string, id: string, owner?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'RetirementPersonalAccount', displayName: string, id: string, owner?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'RevocableTrust', displayName: string, id: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    )> | null, beneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'SCorpBusinessEntity', displayName: string, id: string, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'SLATTrust', displayName: string, id: string, grantor?: (
      { __typename?: 'Principal' }
      & EstateLifeInsurances_OwnerFragment
    ) | null, lifetimeBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, remainderBeneficiaries?: Array<(
      { __typename?: 'Beneficiary' }
      & EstateLifeInsurances_BeneficiaryFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & EstateLifeInsurances_DispositionScenarioFragment
    )> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type EstateLifeInsurancePoliciesListQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  entityIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type EstateLifeInsurancePoliciesListQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EstateLifeInsurances_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EstateLifeInsurancePoliciesList: 'EstateLifeInsurancePoliciesList' as const
  },
  Fragment: {
    EstateLifeInsurances_Owner: 'EstateLifeInsurances_Owner' as const,
    EstateLifeInsurances_Beneficiary: 'EstateLifeInsurances_Beneficiary' as const,
    EstateLifeInsurances_DispositionScenario: 'EstateLifeInsurances_DispositionScenario' as const,
    EstateLifeInsurances_DispositionRecipient: 'EstateLifeInsurances_DispositionRecipient' as const,
    EstateLifeInsurances_BeneficiaryDesignations: 'EstateLifeInsurances_BeneficiaryDesignations' as const,
    EstateLifeInsurances_Entity: 'EstateLifeInsurances_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateLifeInsurances_OwnerFragmentDoc = gql`
    fragment EstateLifeInsurances_Owner on Principal {
  id
  individual {
    id
    displayName
  }
}
    `;
export const EstateLifeInsurances_BeneficiaryFragmentDoc = gql`
    fragment EstateLifeInsurances_Beneficiary on Beneficiary {
  id
}
    `;
export const EstateLifeInsurances_DispositionRecipientFragmentDoc = gql`
    fragment EstateLifeInsurances_DispositionRecipient on DispositiveProvision {
  id
  recipientKind
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  individual {
    id
    displayName
  }
  organization {
    id
    name
  }
  testamentaryEntity {
    id
    displayName
  }
}
    `;
export const EstateLifeInsurances_DispositionScenarioFragmentDoc = gql`
    fragment EstateLifeInsurances_DispositionScenario on DispositionScenario {
  id
  firstGrantorDeath {
    id
    isPrimary
    displayName
  }
  dispositiveProvisions {
    edges {
      node {
        ...EstateLifeInsurances_DispositionRecipient
      }
    }
  }
  secondDeathDispositiveProvisions {
    edges {
      node {
        ...EstateLifeInsurances_DispositionRecipient
      }
    }
  }
}
    ${EstateLifeInsurances_DispositionRecipientFragmentDoc}`;
export const EstateLifeInsurances_BeneficiaryDesignationsFragmentDoc = gql`
    fragment EstateLifeInsurances_BeneficiaryDesignations on BeneficiaryDesignations {
  primary {
    id
    dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
      edges {
        node {
          ...EstateLifeInsurances_DispositionRecipient
        }
      }
    }
  }
}
    ${EstateLifeInsurances_DispositionRecipientFragmentDoc}`;
export const EstateLifeInsurances_EntityFragmentDoc = gql`
    fragment EstateLifeInsurances_Entity on Entity {
  id
  kind
  ownedByStakes {
    id
    ownershipPercentage
    owningIndividual {
      id
      displayName
    }
    owningEntity {
      id
      subtype {
        id
        displayName
      }
    }
  }
  subtype {
    id
    displayName
    ... on IndividualPersonalAccount {
      displayName
      owner {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on InsurancePersonalAccount {
      displayName
      owners {
        ...EstateLifeInsurances_Owner
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      beneficiaryDesignations(hypotheticalWaterfallId: null) {
        ...EstateLifeInsurances_BeneficiaryDesignations
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on JointPersonalAccount {
      displayName
      owners {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on RetirementPersonalAccount {
      displayName
      owner {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on CustodialPersonalAccount {
      displayName
      owner {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on QualifiedTuitionPersonalAccount {
      displayName
      owner {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on ILITTrust {
      displayName
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      grantors {
        ...EstateLifeInsurances_Owner
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on RevocableTrust {
      displayName
      grantors {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on IrrevocableTrust {
      displayName
      grantors {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on SLATTrust {
      displayName
      grantor {
        ...EstateLifeInsurances_Owner
      }
      lifetimeBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      remainderBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on GRATTrust {
      displayName
      grantor {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on QPRTTrust {
      displayName
      grantors {
        ...EstateLifeInsurances_Owner
      }
      beneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on CRTTrust {
      displayName
      grantors {
        ...EstateLifeInsurances_Owner
      }
      lifetimeBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      remainderBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on CLTTrust {
      displayName
      grantors {
        ...EstateLifeInsurances_Owner
      }
      lifetimeBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      remainderBeneficiaries {
        ...EstateLifeInsurances_Beneficiary
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on CCorpBusinessEntity {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on SCorpBusinessEntity {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on GPBusinessEntity {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on LPBusinessEntity {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on LLCBusinessEntity {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on DonorAdvisedFund {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
    ... on PrivateFoundation {
      displayName
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
      dispositionScenarios {
        ...EstateLifeInsurances_DispositionScenario
      }
    }
  }
}
    ${EstateLifeInsurances_OwnerFragmentDoc}
${EstateLifeInsurances_BeneficiaryFragmentDoc}
${EstateLifeInsurances_DispositionScenarioFragmentDoc}
${InsurancePolicies_InsurancePolicyFragmentDoc}
${EstateLifeInsurances_BeneficiaryDesignationsFragmentDoc}`;
export const EstateLifeInsurancePoliciesListDocument = gql`
    query EstateLifeInsurancePoliciesList($householdID: ID!, $entityIDs: [ID!]!) {
  entities(where: {hasHouseholdWith: {id: $householdID}, idIn: $entityIDs}) {
    edges {
      node {
        ...EstateLifeInsurances_Entity
      }
    }
  }
}
    ${EstateLifeInsurances_EntityFragmentDoc}`;

/**
 * __useEstateLifeInsurancePoliciesListQuery__
 *
 * To run a query within a React component, call `useEstateLifeInsurancePoliciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateLifeInsurancePoliciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateLifeInsurancePoliciesListQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      entityIDs: // value for 'entityIDs'
 *   },
 * });
 */
export function useEstateLifeInsurancePoliciesListQuery(baseOptions: Apollo.QueryHookOptions<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>(EstateLifeInsurancePoliciesListDocument, withFetchPolicyContext(options));
      }
export function useEstateLifeInsurancePoliciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>(EstateLifeInsurancePoliciesListDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateLifeInsurancePoliciesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>(EstateLifeInsurancePoliciesListDocument, withFetchPolicyContext(options));
        }
export type EstateLifeInsurancePoliciesListQueryHookResult = ReturnType<typeof useEstateLifeInsurancePoliciesListQuery>;
export type EstateLifeInsurancePoliciesListLazyQueryHookResult = ReturnType<typeof useEstateLifeInsurancePoliciesListLazyQuery>;
export type EstateLifeInsurancePoliciesListSuspenseQueryHookResult = ReturnType<typeof useEstateLifeInsurancePoliciesListSuspenseQuery>;
export type EstateLifeInsurancePoliciesListQueryResult = Apollo.QueryResult<EstateLifeInsurancePoliciesListQuery, EstateLifeInsurancePoliciesListQueryVariables>;